import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["innerHTML"]

import { computed } from 'vue'
import { useSessionStore } from 'app_alegra_commons/session'


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationBoxTop',
  setup(__props) {

const SESSION = useSessionStore()

const app_env = computed(() => {
  const appEnviroment = String(process.env.VUE_APP_ENVIROMENT).toLowerCase()
  return appEnviroment == 'local' ? 'testing' : appEnviroment
})

const idGlobal = computed(() => SESSION.user.idGlobal)

const notificationBoxTop = computed(() => {
  return `
    <notifications-top-box
      app_env="${app_env.value}"
      application="alegra-web"
      user_id="${idGlobal.value}"
    />
  `
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (idGlobal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          innerHTML: notificationBoxTop.value
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true)
  ]))
}
}

})